import httpClient from '../../httpClient';
import { DataRoomMember } from 'router/subrouters/DataRoom/models/DataRoomMember';
import { NodeChangedPermission } from 'components/FileAccessSelector/types';

function updateMemberDocuments(
  memberId: string,
  data: {
    changedPermissions?: NodeChangedPermission[];
  },
) {
  return httpClient.patch<{ dataRoomMember: DataRoomMember }>(
    `data-room-members/${memberId}`,
    data,
  );
}

export default {
  updateMemberDocuments,
};
